import { registerAppConfig } from "@base/config";
import { paymentsConfig, siteConfig, siteMetadata } from "@/conf";
import { trackers } from "@/trackers";

// Must stay the FIRST import of gatsby-browser.tsx and gatsby-ssr.tsx so the
// registry is populated before any @base module evaluates.
registerAppConfig({ siteConfig, siteMetadata, paymentsConfig, trackers });
